import React, { useEffect, useRef, useState } from 'react';
import {
   Box,
   Button,
   Grid,
   Modal,
   Paper,
   Step,
   StepLabel,
   Stepper,
   Typography,
} from '@material-ui/core/';
import { myContainerStyle } from '../../../configs/ui/constant';
import { useSnackbar } from 'notistack';
import { FilePond, registerPlugin } from 'react-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import { MySelect } from '../../../components/Select/Select';
import Axios from 'axios';
import { useForm } from 'react-hook-form';
import { Input } from '../../../assets/styled/Element';
import FileSaver from 'file-saver';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import LoadingPopup from '../../../components/Loading/LoadingPopup';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';
import { ImportLabel } from '../../../components/Status/StatusLabel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { faFileDownload } from '@fortawesome/pro-duotone-svg-icons';
import { LinearProgress } from '@material-ui/core';

registerPlugin(FilePondPluginFileValidateType);

const TIMER = 25;

const useStyles = makeStyles((theme) => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
}));

const options = [
   // {
   //   label: 'adminFile',
   //   value: '/GSB/dashboard/file/UploadAdmin',
   // },
   {
      label: 'Upload-Activity',
      value: '/GSB/dashboard/file/UploadActivity',
      name: 'activityFile',
      fileType: 3,
   },
   {
      label: 'Upload-PointFile',
      value: '/GSB/dashboard/file/UploadPointFileV2',
      name: 'pointFile',
      fileType: 1,
   },
   {
      label: 'Upload-Activity-PointFile',
      value: '/GSB/dashboard/file/UploadActivityPointFileV2',
      name: 'activityPointFile',
      fileType: 8,
   },
   {
      label: 'Upload-RuleFile',
      value: '/GSB/dashboard/file/UploadRule',
      name: 'ruleFile',
      fileType: 6,
   },
   // {
   //   label: 'Upload-Position',
   //   value: '/GSB/dashboard/file/UploadPosition',
   //   name: 'formFile',
   //   fileType: 4,
   // },
   // {
   //   label: 'Upload-Division',
   //   value: '/GSB/dashboard/file/UploadDivision',
   //   name: 'formFile',
   //   fileType: 5,
   // },
];

const perCent = (a, b) => Math.round((a / b) * 100);

const BorderLinearProgress = withStyles((theme) => ({
   root: {
      height: 20,
      borderRadius: 5,
   },
   colorPrimary: {
      backgroundColor:
         theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
   },
   bar: {
      borderRadius: 5,
      backgroundColor: '#51d600',
   },
}))(LinearProgress);
const BorderLinearProgressWaring = withStyles((theme) => ({
   root: {
      height: 20,
      borderRadius: 5,
   },
   colorPrimary: {
      backgroundColor:
         theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
   },
   bar: {
      borderRadius: 5,
      backgroundColor: '#ff8c00',
   },
}))(LinearProgress);

function getSteps() {
   return ['เลือกประเภทของข้อมูล', 'อัพโหลดไฟล์', 'นำเข้าข้อมูล'];
}
function getStepContent(stepIndex) {
   switch (stepIndex) {
      case 0:
         return 'Select campaign settings...';
      case 1:
         return 'What is an ad group anyways?';
      case 2:
         return 'This is the bit I really care about!';
      default:
         return 'Unknown stepIndex';
   }
}
const Import = () => {
   const [importSelet, setImportSelet] = useState([
      {
         label: '',
         value: '',
         name: '',
         fileType: 0,
      },
   ]);
   const classes = useStyles();
   const inputFileRef = useRef();
   const [errorFileName, setErrorFileName] = useState('');
   const [files, setFiles] = useState([]);
   const [disableUpload, setDisableUpload] = useState(true);
   const [showModal, setShowModal] = useState(false);
   const [errorMessage, setErrorMessage] = useState(
      'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
   );
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [activeStep, setActiveStep] = useState(0);
   const { handleSubmit, register, errors, control } = useForm();
   const [rowValue, setRowValue] = useState({
      rowStart: 0,
      rowEnd: 0,
   });
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const tableRef = useRef();
   const [timeLeft, setTimeLeft] = useState(TIMER);
   const [pageSize, setPageSize] = useState(5);

   useEffect(() => {
      // exit early when we reach 0
      if (timeLeft === 0) return refreshData();
      if (!timeLeft) return;

      // save intervalId to clear the interval when the
      // component re-renders
      const intervalId = setInterval(() => {
         setTimeLeft(timeLeft - 1);
      }, 1000);

      // clear interval on re-render to avoid memory leaks
      return () => clearInterval(intervalId);
      // add timeLeft as a dependency to re-rerun the effect
      // when we update it
   }, [timeLeft]);

   const steps = getSteps();

   const handleNext = () => {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
   };

   const handleBack = () => {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
   };

   const handleReset = () => {
      setActiveStep(0);
   };

   const upLoadFile = (
      fieldName,
      file,
      metadata,
      load,
      error,
      progress,
      abort,
   ) => {
      const formData = new FormData();
      setShowModal(true);
      if (
         importSelet.label === 'Upload-PointFile' ||
         importSelet.label === 'Upload-Activity-PointFile'
      ) {
         formData.append('pointFile', file, file.name);
         // formData.append('rowStart', rowValue.rowStart);
         // formData.append('rowEnd', rowValue.rowEnd);
         formData.append('rowStart', 0);
         formData.append('rowEnd', 0);
      } else formData.append(importSelet.name, file, file.name);

      const CancelToken = Axios.CancelToken;
      const source = CancelToken.source();

      Axios({
         method: 'POST',
         url: importSelet.value,
         data: formData,
         cancelToken: source.token,
         onUploadProgress: (e) => {
            progress(e.lengthComputable, e.loaded, e.total);
         },
      })
         .then((response) => {
            load(response);
            // if (
            //   importSelet.label === 'Upload-Position' ||
            //   importSelet.label === 'Upload-Division'
            // ) {
            //   enqueueSnackbar('สำเร็จ', {
            //     variant: 'success',
            //   });
            //   handleNext();
            // } else {
            //   // console.log('case 2');
            //   if (response.data.failedRecord.length > 0) {
            //     getErrorFile(response.data.errorFileName);
            //     setErrorMessage('เกิดข้อผิดพลาด กรุณาตรวจสอบข้อมูล');
            //     return error();
            //   } else if (response.data.successfulRecord.length > 0) {
            //     postDataCreated(response.data.successfulRecord);
            //     handleNext();
            //   } else error();
            // }
            enqueueSnackbar('สำเร็จ', {
               variant: 'success',
            });
            handleNext();
         })
         .catch((err) => {
            LogToBackend(err);
            error(err);
            if (Axios.isCancel(err)) {
               // console.log("Request canceled", err.message);
            } else {
               // handle error
            }
         })
         .finally(() => {
            setShowModal(false);
            refreshData();
         });
      return {
         abort: () => {
            source.cancel('Operation canceled by the user.');
            abort();
         },
      };
   };
   const getErrorFile = (e) => {
      setShowModal(true);
      Axios.get(`/GSB/dashboard/file/DownloadErrorPointFile?filename=${e}`, {
         responseType: 'blob',
      })
         .then((response) => {
            if (response) {
               FileSaver.saveAs(new Blob([response.data]), e);
            }
         })
         .finally(() => {
            setShowModal(false);
         });
   };
   const handleChangeSelect = (e) => {
      inputFileRef.current.removeFiles();
      if (e) {
         setImportSelet({ ...e });
         // if (e.label === 'Upload-PointFile') setDisableUpload(true);
         // else setDisableUpload(false);
         setDisableUpload(false);
         handleNext();
      } else {
         setImportSelet([
            {
               label: '',
               value: '',
               name: '',
               fileType: 0,
            },
         ]);
         setFiles([]);
         setDisableUpload(true);
         handleBack();
      }
   };
   const postDataCreated = (dataCreated) => {
      enqueueSnackbar('อัพโหลดไฟล์สมบูรณ์แล้ว ระบบกำลังคัดแยกข้อมูล', {
         variant: 'info',
      });
      if (importSelet.label === 'adminFile') {
         let endpointPost = '';
         let payload = {};

         if (importSelet.label === 'adminFile') {
            endpointPost = '/GSB/dashboard/user/BatchCreateAdminManager';
            payload = { adminList: dataCreated };
         }
         if (importSelet.label === 'Upload-Activity') {
            endpointPost = '/GSB/dashboard/activity/BatchCreateActivity';
            payload = { activityList: dataCreated };
         }
         setShowModal(true);
         Axios.post(endpointPost, payload)
            .then((response) => {
               handleNext();
               enqueueSnackbar('สำเร็จ', {
                  variant: 'success',
               });
            })
            .catch((err) => {
               LogToBackend(err);
               enqueueSnackbar('เกิดข้อผิดพลาด กรุณาตรวจสอบข้อมูล', {
                  variant: 'error',
               });
            })
            .finally(() => {
               setShowModal(false);
            });
      } else {
         handleNext();
         enqueueSnackbar('สำเร็จ', {
            variant: 'success',
         });
         return false;
      }
   };
   const refreshData = () => {
      setTimeLeft(TIMER);
      tableRef.current && tableRef.current.onQueryChange();
   };
   const onSubmit = (data) => {
      setDisableUpload(false);
      setRowValue(data);
   };
   const renderInput = () => {
      if (!importSelet.label) return false;
      else if (importSelet.label === 'Upload-PointFile') {
         return (
            <React.Fragment>
               <form onSubmit={handleSubmit(onSubmit)}>
                  <Box display={'flex'} flexDirection={'column'} m={1}>
                     <Box display={'flex'}>
                        <Box mr={'2.5px'}>
                           <Input
                              placeholder={'rowStart'}
                              type={'number'}
                              name='rowStart'
                              ref={register}
                           />
                        </Box>
                        <Box ml={'2.5px'}>
                           <Input
                              placeholder={'rowEnd'}
                              type={'number'}
                              name='rowEnd'
                              ref={register}
                           />
                        </Box>
                     </Box>
                     <Box mt={'5px'} alignSelf={'flex-end'}>
                        <Button
                           type={'submit'}
                           variant={'contained'}
                           color={'primary'}
                        >
                           ยืนยัน
                        </Button>
                     </Box>
                  </Box>
               </form>
            </React.Fragment>
         );
      } else return false;
   };
   const sampleFile = () => {
      Axios.get(
         `/GSB/dashboard/file/DownloadTemplate?fileType=${importSelet.fileType}`,
         {
            responseType: 'blob',
         },
      ).then((response) => {
         if (response) {
            if (
               importSelet.label === 'Upload-Position' ||
               importSelet.label === 'Upload-Division'
            ) {
               FileSaver.saveAs(
                  new Blob([response.data]),
                  `Template_${importSelet.label}_File.txt`,
               );
            } else {
               FileSaver.saveAs(
                  new Blob([response.data]),
                  `Template_${importSelet.label}_File.xlsx`,
               );
            }
         }
      });
   };

   return (
      <Paper style={myContainerStyle.root}>
         <Modal className={classes.modal} open={showModal}>
            <React.Fragment>
               <LoadingPopup />;
            </React.Fragment>
         </Modal>
         <Typography variant='h5' gutterBottom>
            นำเข้าข้อมูล
         </Typography>
         <Box fontSize={20}>
            <Box>
               <Stepper activeStep={activeStep} alternativeLabel>
                  {steps.map((label) => (
                     <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                     </Step>
                  ))}
               </Stepper>
            </Box>
            <Box
               display='flex'
               justifyContent='center'
               alignContent='center'
               alignItems='center'
               width={'75%'}
               my={0}
               mx={'auto'}
            >
               <Grid container>
                  <Grid item xs={3}>
                     <Box m={1}>
                        <Typography variant='h6'>
                           เลือกประเภทของข้อมูล
                        </Typography>
                        <MySelect
                           name={'เลือกประเภทของข้อมูล'}
                           title={'เลือกประเภทของข้อมูล'}
                           closeMenuOnSelect
                           options={options}
                           menuShowInbody
                           onChange={handleChangeSelect}
                           onMenuOpen={() => {
                              setActiveStep(0);
                           }}
                        />
                     </Box>
                     {/*<Box>{renderInput()}</Box>*/}
                  </Grid>
                  <Grid item xs={9}>
                     <Box m={1} display={'flex'} flexDirection={'column'}>
                        {importSelet.fileType && (
                           <Button
                              variant={'contained'}
                              color={'primary'}
                              onClick={sampleFile}
                              style={{ margin: '10px 0' }}
                           >
                              {`ตัวอย่างไฟล์: ${importSelet.label}`}
                           </Button>
                        )}
                        <FilePond
                           disabled={disableUpload}
                           ref={inputFileRef}
                           abelFileProcessingError='Invalid name or format'
                           allowFileRename={false}
                           maxFileSize='500MB'
                           // acceptedFileTypes="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.oasis.opendocument.spreadsheet,text/plain"
                           labelIdle={
                              disableUpload
                                 ? 'กรุณาเลือกประเภทของข้อมูลก่อน'
                                 : `คุณเลือก ${importSelet.label} , ลากและวาง หรือ 
                    <span class="filepond--label-action">ค้นหา</span>
                  `
                           }
                           labelFileProcessingError={errorMessage}
                           allowMultiple={false}
                           maxFiles={1}
                           maxParallelUploads={1}
                           server={{
                              process: (
                                 fieldName,
                                 file,
                                 metadata,
                                 load,
                                 error,
                                 progress,
                                 abort,
                              ) => {
                                 upLoadFile(
                                    fieldName,
                                    file,
                                    metadata,
                                    load,
                                    error,
                                    progress,
                                    abort,
                                 );
                              },
                           }}
                           onupdatefiles={(fileItems) => {
                              const tmp = fileItems.map(
                                 (fileItem) => fileItem.file,
                              );
                              setFiles(tmp);
                           }}
                        />
                     </Box>
                  </Grid>
               </Grid>
            </Box>
            <Box>
               <MaterialTable
                  tableRef={tableRef}
                  columns={[
                     {
                        field: 'importStatus',
                        title: 'Import Status',
                        headerStyle: {
                           textAlign: 'center',
                        },
                        cellStyle: {
                           textAlign: 'center',
                        },
                        render: (rowData) => (
                           <ImportLabel
                              StatusType={rowData.importStatus}
                              msg={rowData.importStatus}
                           />
                        ),
                     },
                     {
                        field: 'uploadDate',
                        title: 'Upload Date',
                        type: 'datetime',
                     },
                     {
                        field: 'updatedDate',
                        title: 'Updated Date',
                        type: 'datetime',
                     },
                     {
                        field: 'fileName',
                        title: 'File Name',
                     },
                     {
                        field: 'fileTypeLabel',
                        title: 'File Type',
                     },
                     {
                        field: 'total',
                        title: 'Total',
                     },
                     {
                        field: 'pass',
                        title: 'Pass',
                        headerStyle: {
                           textAlign: 'center',
                        },
                        cellStyle: {
                           textAlign: 'center',
                        },
                     },
                     {
                        field: 'failed',
                        title: 'Failed',
                        headerStyle: {
                           textAlign: 'center',
                        },
                        cellStyle: {
                           textAlign: 'center',
                        },
                     },
                     {
                        field: 'fileStatus',
                        title: 'File Status',
                        sorting: false,
                        export: false,
                        headerStyle: {
                           textAlign: 'center',
                        },
                        cellStyle: {
                           textAlign: 'center',
                        },
                        render: (rowData) => {
                           if (rowData.total) {
                              if (perCent(rowData.pass, rowData.total) < 100) {
                                 return (
                                    <div
                                       style={{
                                          position: 'relative',
                                          fontFamily: 'GSB',
                                          color: '#8c8c8c',
                                       }}
                                    >
                                       <BorderLinearProgressWaring
                                          variant='determinate'
                                          value={perCent(
                                             rowData.pass,
                                             rowData.total,
                                          )}
                                       />
                                       <div
                                          style={{
                                             position: 'absolute',
                                             top: '50%',
                                             left: '50%',
                                             transform: 'translate(-50%, -50%)',
                                          }}
                                       >
                                          {`${rowData.transferred}/${rowData.total}`}
                                       </div>
                                    </div>
                                 );
                              } else {
                                 return (
                                    <div
                                       style={{
                                          position: 'relative',
                                          fontFamily: 'GSB',
                                          color: '#fff',
                                       }}
                                    >
                                       <BorderLinearProgress
                                          variant='determinate'
                                          value={perCent(
                                             rowData.pass,
                                             rowData.total,
                                          )}
                                       />
                                       <div
                                          style={{
                                             position: 'absolute',
                                             top: '50%',
                                             left: '50%',
                                             transform: 'translate(-50%, -50%)',
                                          }}
                                       >
                                          {`${rowData.transferred}/${rowData.total}`}
                                       </div>
                                    </div>
                                 );
                              }
                           }
                        },
                     },
                  ]}
                  data={(query) =>
                     new Promise((resolve, reject) => {
                        Axios.get(
                           `/GSB/dashboard/file/GetUploadList?per_page=${
                              query.pageSize
                           }&page=${query.page + 1}`,
                        )
                           .then((response) => {
                              setPageSize(query.pageSize);
                              resolve({
                                 data: response.data.data,
                                 page: response.data.page - 1,
                                 totalCount: response.data.total,
                              });
                           })
                           .catch((e) => {
                              LogToBackend(e);
                              reject(e);
                              setIsError({
                                 error: true,
                                 errorStatus: e.response.status,
                                 errorMessage: e.response.data.errorAppMessageTh
                                    ? e.response.data.errorAppMessageTh
                                    : 'เกิดข้อผิดพลาด',
                              });
                           });
                     })
                  }
                  options={{
                     // selection: true,
                     showTitle: false,
                     headerStyle: headerStyle,
                     actionsColumnIndex: -1,
                     addRowPosition: 'first',
                     actionsCellStyle: {
                        color: '#ccc',
                     },
                     padding: 'dense',
                     pageSize: pageSize,
                     pageSizeOptions: [5, 10, 25, 50, 100],
                  }}
                  localization={{
                     body: {
                        editRow: {
                           deleteText: 'ต้องการลบข้อมูลนี้ใช่หรือไม่?',
                        },
                     },
                     // header: { actions: 'ตัวจัดการ' },
                  }}
                  style={tableStyle}
                  icons={tableIcons}
                  actions={[
                     {
                        icon: React.forwardRef((props, ref) => (
                           <FontAwesomeIcon
                              ref={ref}
                              {...props}
                              icon={faRedoAlt}
                              size={'xs'}
                           />
                        )),
                        tooltip: 'Refresh Data',
                        isFreeAction: true,
                        onClick: () => refreshData(),
                     },
                     (rowData) => {
                        if (rowData.isHasErrorFileForDownload)
                           return {
                              icon: React.forwardRef((props, ref) => (
                                 <FontAwesomeIcon
                                    ref={ref}
                                    {...props}
                                    icon={faFileDownload}
                                    color='#00a2e8'
                                 />
                              )),
                              tooltip: 'ดาวน์โหลดไฟล์',
                              onClick: (event, rowData) =>
                                 getErrorFile(rowData.errorFileName),
                           };
                     },
                  ]}
               />
            </Box>
         </Box>
      </Paper>
   );
};

export default Import;
